// extracted by mini-css-extract-plugin
module.exports = {"mainWrap":"searchBar_mainWrap__Fdpqs","inputWrap":"searchBar_inputWrap__yL9BN"};